import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import api from '../../../services/api';

import * as S from '../../../components/utilities/styledComponents/Gearbox';

import './style/style.scss';

import iconMegaphone from '../../../img/megaphone.svg';
import FormUser from '../../../components/FormUser';
import Card from '../../../components/Card';
import { ContentTitle } from '../../../components/utilities/styledComponents/ContentTitle';
import { CockpitFormGroupStyle } from '../../../components/utilities/styledComponents/CockpitFormGroupStyle';

class UserEdit extends Component {
	state = {
		redirectToUsers: false,
		formValues: { nome: '', email: '' },
	};

	componentDidMount() {
		this.getUser();
	}

	getUriForApi = () => {
		const { match } = this.props;
		return `/users/${match.params.userId}`;
	};

	getUser = () => {
		api.get(this.getUriForApi())
			.then((response) => {
				this.setState({
					formValues: response.data.data.attributes,
				});
			})
			.catch(() => {
				this.setState({
					redirectToUsers: true,
				});
			});
	};

	render() {
		const { redirectToUsers, formValues } = this.state;

		const { location } = this.props;

		return (
			<CockpitFormGroupStyle>
				{redirectToUsers === true
					? (
						<Redirect to={
							{ pathname: '/backoffice/usuarios', state: { formMessage: 'Falha ao carregar usuário' } }
						}
						/>
					)
					: ''}
				<S.MainContent id="gearbox-content">
					<div className="App">
						<ContentTitle>{location.action === 'editUser' ? 'Usuário' : 'Digite uma nova senha'}</ContentTitle>
						<div className="container">
							<div className="row">
								<div className="col-12">
									<Card
										icon={iconMegaphone}
										classComponent="m-3"
										altIcon=""
										titleIcon="Dados do usuário"
										title="Dados do usuário"
										classButton=""
										textButton=""
										linkButton={null}
										eventButton={null}
										targetButton=""
									>
										<FormUser
											messageSuccess="Usuário atualizado com sucesso!"
											formValues={formValues}
											apiUri={this.getUriForApi()}
											apiMethod="put"
										/>
									</Card>
								</div>
							</div>
						</div>
					</div>
				</S.MainContent>
			</CockpitFormGroupStyle>
		);
	}
}

export default UserEdit;
